import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { useEntityList } from '../../data/entities';
import WorkspaceDatasets from '../../components/WorkspaceDatasets';

// Listen module (org-wide view): datasets grouped by workspace. Select a
// project in the sidebar for the scoped view.
export default function ListenModule() {
  const { org } = useOutletContext();
  const { docs: workspaces } = useEntityList('workspace', { org: org.id });

  return (
    <div data-nova-note="Listen · Datasets: files on shared storage per workspace, mounted into every workload and pipeline. NoVA: create_dataset, list_dataset; uploads are the person's drag-and-drop.">
      <h1 style={{ margin: 0 }}>Listen · Datasets</h1>
      <p className="cs-help" style={{ marginTop: 6 }}>
        Files on shared storage, mounted into every workload and pipeline
        block. Use the <code>input.dataset</code> / <code>output.dataset</code>{' '}
        blocks or <code>ORG_DATASETS_DIR</code> in workload scripts.
      </p>
      {workspaces && !workspaces.length && (
        <div className="cs-empty" style={{ marginTop: 16 }}>No workspaces yet.</div>
      )}
      {(workspaces || []).map((ws) => (
        <section key={ws.id} style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
            <h2 style={{ margin: 0, fontSize: 18 }}>{ws.name}</h2>
            <Link to={`/orgs/${org.id}/ws/${ws.id}`} className="cs-help" style={{ fontSize: 12 }}>
              open workspace →
            </Link>
          </div>
          <WorkspaceDatasets orgId={org.id} workspaceId={ws.id} compact />
        </section>
      ))}
    </div>
  );
}
